import { render, staticRenderFns } from "./InternalForm.vue?vue&type=template&id=251a589c&scoped=true&"
import script from "./InternalForm.vue?vue&type=script&lang=js&"
export * from "./InternalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251a589c",
  null
  
)

export default component.exports